import { createAsyncThunk } from '@reduxjs/toolkit';
import { REPORTS } from '../../constant';
import { getToken } from '../../Utils/authUtils';

interface Payload {
  reportId: string;
}

export interface RegenerateReportResult {
  reportId: string;
  templateName: string;
  /** The clinic's current template, still holding its {{placeholders}}. */
  templateHTML: string;
  hospitalHeader: any;
  hospitalLogo: string | null;
  /** Fields kept across a regenerate. Never includes the old body. */
  report: {
    _id: string;
    status?: string;
    reportType?: string;
    studyInstanceUID?: string;
    createdByName?: string;
    reportAssignedTo?: string;
    reportAssignedToId?: string;
    colorCode?: any;
    attachedClips?: any[];
    sharedClipsId?: string;
    sharedClipsUrl?: string;
    sharedClipsName?: string;
  };
}

export const regenerateReport = createAsyncThunk<
  RegenerateReportResult,
  Payload,
  { rejectValue: string }
>('regenerateReport', async (payload, { rejectWithValue }) => {
  try {
    const res = await fetch(REPORTS.REGENERATE_REPORT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getToken()}`,
      },
      body: JSON.stringify(payload),
    });
    const body = await res.json().catch(() => ({}));
    if (!res.ok) {
      return rejectWithValue(body?.message || 'Could not regenerate the report.');
    }
    return body.data as RegenerateReportResult;
  } catch {
    return rejectWithValue('Could not reach the server. Check your connection and try again.');
  }
});
